<template>
  <el-empty style="height:100%;line-height: 100%" description="404 找不到页面"></el-empty>
</template>

<script>
export default {
  name: "not404",
}
</script>

<style scoped>

</style>